import type { PermissionName } from "./catalog";
import { PERMISSIONS } from "./constants";
import { hasPermissionInList } from "./checks";
import { hasModuleAccess } from "./module-access";
import type { UserPermission } from "./types";

/** User can see incoming transfer tables/screens */
export function canViewTransferIncoming(
  userPermissions: readonly UserPermission[],
): boolean {
  return hasPermissionInList(
    userPermissions,
    PERMISSIONS.TRANSFER_VIEW_INCOMING,
  );
}

/** User can see outgoing transfer tables/screens */
export function canViewTransferOutgoing(
  userPermissions: readonly UserPermission[],
): boolean {
  return hasPermissionInList(
    userPermissions,
    PERMISSIONS.TRANSFER_VIEW_OUTGOING,
  );
}

/** Branch user: both incoming and outgoing view access */
export function isBranchTransferUser(
  userPermissions: readonly UserPermission[],
): boolean {
  return (
    canViewTransferIncoming(userPermissions) &&
    canViewTransferOutgoing(userPermissions)
  );
}

/** Central Kitchen user: exactly one of incoming/outgoing view (not both) */
export function isCentralKitchenTransferUser(
  userPermissions: readonly UserPermission[],
): boolean {
  const incoming = canViewTransferIncoming(userPermissions);
  const outgoing = canViewTransferOutgoing(userPermissions);
  return (incoming || outgoing) && !(incoming && outgoing);
}

/** Show Transfers item in sidebar */
export function canAccessTransfersNav(
  userPermissions: readonly UserPermission[],
): boolean {
  return (
    canViewTransferIncoming(userPermissions) ||
    canViewTransferOutgoing(userPermissions) ||
    hasModuleAccess(userPermissions, "transfer")
  );
}

export function getTransferViewPermissions(): PermissionName[] {
  return [
    PERMISSIONS.TRANSFER_VIEW_INCOMING,
    PERMISSIONS.TRANSFER_VIEW_OUTGOING,
  ];
}
